import React, { useEffect, useState } from 'react';
import './Skills.css';
import { getSkills } from '../data/localDataService';

import {
  FaChartLine,
  FaCoins,
  FaCubes,
  FaDatabase,
  FaEthereum,
  FaHandshake,
  FaLayerGroup,
  FaLink,
  FaNetworkWired,
  FaPenNib,
  FaPuzzlePiece,
  FaPython,
  FaRobot,
  FaSearch,
  FaServer,
  FaUsers,
  FaWallet,
} from 'react-icons/fa';
import { SiRust } from 'react-icons/si';
import { Skill } from '../types';

const iconMap: { [key: string]: JSX.Element } = {
  // Contracted additions
  FaRobot: <FaRobot />,
  FaNetworkWired: <FaNetworkWired />,
  FaPuzzlePiece: <FaPuzzlePiece />,
  SiRust: <SiRust />,
  // Icons referenced by portfolio.json skills
  FaEthereum: <FaEthereum />,
  FaCoins: <FaCoins />,
  FaChartLine: <FaChartLine />,
  FaSearch: <FaSearch />,
  FaPython: <FaPython />,
  FaDatabase: <FaDatabase />,
  FaLayerGroup: <FaLayerGroup />,
  FaHandshake: <FaHandshake />,
  FaUsers: <FaUsers />,
  FaServer: <FaServer />,
  FaCubes: <FaCubes />,
  FaLink: <FaLink />,
  FaWallet: <FaWallet />,
  FaPenNib: <FaPenNib />,
};

const Skills: React.FC = () => {
  const [skillsData, setSkillsData] = useState<Skill[]>([]);

  useEffect(() => {
    async function fetchSkills() {
      const data = await getSkills();
      setSkillsData(data);
    }

    fetchSkills();
  }, []);

  if (skillsData.length === 0) {
    return (
      <div className="skills-container">
        <p className="skills-loading" role="status" aria-live="polite" aria-busy="true">
          Loading skills…
        </p>
      </div>
    );
  }

  const skillsByCategory = skillsData.reduce<Record<string, Skill[]>>((acc, skill) => {
    if (!acc[skill.category]) acc[skill.category] = [];
    acc[skill.category].push(skill);
    return acc;
  }, {});

  return (
    <div className="skills-container">
      <h1 className="skills-title">Skills</h1>
      {Object.keys(skillsByCategory).map((category) => (
        <section key={category} className="skill-category">
          <h2 className="category-title">{category}</h2>
          <div className="skills-grid">
            {skillsByCategory[category].map((skill) => (
              <article key={skill.name} className="skill-card">
                <div className="skill-head">
                  <span className="skill-icon" aria-hidden="true">
                    {iconMap[skill.icon] ?? <FaLayerGroup />}
                  </span>
                  <h3 className="skill-name">{skill.name}</h3>
                </div>
                <p className="skill-description">{skill.description}</p>
              </article>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default Skills;
